export default __webpack_public_path__ + "static/media/client-7.6dac51fa.png";